import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../theme';
import { absolute } from '../styles/mixins';

export const useBaseLoggedPageStyles = createStyles(({ token }) => ({
  root: {
    ...absolute(),
    backgroundColor: ThemeColors.COLOR_WHITE2,
  },
  content: {
    width: '100%',
    height: '100%',
    minWidth: token.screenXSMin,
    display: 'flex',
    flexDirection: 'column',
    padding: ThemeSpaces.SPACE_NORM,
    paddingBottom: 0,
  },
  innerContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: ThemeSpaces.SPACE_NORM,

    [`@media (max-width: ${token.screenSMMax}px)`]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
}));
